import React, { ReactNode } from 'react';
import { Avatar } from './Avatar';
import { cn } from 'src/utils/Functions';

interface ChitAvatarProps {
  fallback?: string;
  src?: string;
  size?: 'sm' | 'default' | 'md' | 'lg' | 'xl' | '2xl';
  icon?: ReactNode;
  className?: string;
}

export const ChitAvatar: React.FC<ChitAvatarProps> = ({
  fallback,
  src,
  size = 'lg',
  icon,
  className
}) => {
  if (icon) {
    // Icon-based avatar for things like settings items
    const sizeClasses = {
      sm: 'w-6 h-6 text-lg',
      default: 'w-8 h-8 text-xl', 
      md: 'w-10 h-10 text-2xl',
      lg: 'w-12 h-12 text-2xl',
      xl: 'w-16 h-16 text-3xl',
      '2xl': 'w-20 h-20 text-4xl'
    };

    return (
      <div className={cn(
        "flex items-center justify-center rounded-full bg-white/10 text-white/40",
        sizeClasses[size],
        className
      )}>
        {icon}
      </div>
    );
  }

  // Regular avatar for users/organizations
  return (
    <Avatar
      fallback={fallback || '??'}
      src={src}
      className={cn("bg-white/10 text-white", className)}
    />
  );
};